import { toLocaleString } from '@/utils/format/number';
/**
 * 案件の予算に応じたテキストを返す
 * @param options
 */
export const getProfessionalRfpBudgetText = (options) => {
    const { budget, maxBudget, unit = '万円' } = options;
    // 予算が設定されていない場合
    if (!budget && !maxBudget) {
        return 'OPEN';
    }
    const min = budget ? `${toLocaleString(budget)}${unit}` : '';
    const max = maxBudget ? `${toLocaleString(maxBudget)}${unit}` : '';
    return `${min}～${max}`;
};
